import {ChildEntity} from "typeorm";
import {StaffMember} from "@/modules/staff/entity";

@ChildEntity()
export class Negotiator extends StaffMember {
}
